import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewsCountPopoverPage } from './views-count-popover.page';

const routes: Routes = [
  {
    path: '',
    component: ViewsCountPopoverPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ViewsCountPopoverPage]
})
export class ViewsCountPopoverPageModule {}
